export type ThemeStyleT = {
  theme: {
    body: string;
    text: string;
  };
};

export const lightTheme = {
  body: "#ffffff",
  text: "#000000",
  error: "#fe0021",
  primary: "#cab3fa",
  secondary: "#2e2a36",
  lightPink: "#f8f6fe",
  newPink: "#ebe4ff",
  lightPurple: "#ebe4ff",
  darkPurple: "#9791c3",
  lightGray: "#7a787c",
  darkGray: "#7a787c",
  darkerGray: "#7a787c",
  darkestGray: "#828282",
  darkestGray2: "#828282",
  darkThemePrimary: "#000000",
  grayBackground: "#dadada",
  grayBackground2: "#c4c4c4",
  grayBorder: "1px solid #f2f2f2",
  linearGradient: "rgba(255, 255, 255, 0) 0%, #ffffff",
  linearGradientLight: "rgba(205, 205, 205, 72%) 0%, #ffffff",
  firstLayer: "#ffffff",
  secondLayer: "#f1edff",
  lightBorder: "rgb(242, 242, 242, 0.9)",
  overlayColor: "rgba(0, 0, 0, 0.15)",
  opacityText: "rgba(0, 0, 0, 0.5)",
  shadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
  shimmer:
    "linear-gradient(to right, #f0f0f0 0%, #d8d8d8 20%, #f0f0f0 40%, #f0f0f0 100%);",
  transparentBackground: "rgba(193, 193, 193, 0.6)",
};

export const darkTheme = {
  body: "#000000",
  text: "#ffffff",
  error: "#fe0021",
  primary: "#cab3fa",
  secondary: "#2e2a36",
  lightPink: "#2e2a36",
  newPink: "#d0c9e5",
  lightPurple: "#403750",
  darkPurple: "#9791c3",
  lightGray: "#ffffff",
  darkGray: "#7a787c",
  darkerGray: "#ffffff",
  darkestGray: "#ffffff",
  darkestGray2: "#828282",
  grayBackground: "rgba(218, 218, 218, 0.2)",
  grayBackground2: "#4a4a4a",
  darkThemePrimary: "#cab3fa",
  grayBorder: "1px solid #828282",
  linearGradient: "rgba(0, 0, 0, 0) 0%, #000000",
  linearGradientLight: "rgba(0, 0, 0, 0) 0%, #000000",
  firstLayer: "#19161e",
  secondLayer: "#484059",
  lightBorder: "rgb(242, 242, 242, 0.2)",
  overlayColor: "rgba(0, 0, 0, 0.70)",
  opacityText: "rgba(0, 0, 0, 0.70)",
  shadow: "none",
  shimmer:
    "linear-gradient( to right, #50535a 0%, #656871 20%, #50535a 40%, #50535a 100%);",
  transparentBackground: "rgba(193, 193, 193, 0.6)",
};
